import {
  API_GET_CLOSING_COST_SETUP,
  API_LOAN_ADD_CLOSING_COSTS,
  API_LOAN_ADD_CREDIT_DENIAL,
  API_LOAN_CHANGE_FEE_WORKSHEET_TEMPLATE,
  API_LOAN_CLOSING_COST_ESTIMATE_HUD1,
  API_LOAN_DELETE_CLOSING_COST,
  API_LOAN_DOWNLOAD_AGGREGATE_ESCROW,
  API_LOAN_DOWNLOAD_CLOSING_INFORMATION,
  API_LOAN_DOWNLOAD_CREDIT_DENIAL,
  API_LOAN_DOWNLOAD_DISBURSEMENT_ITEMS,
  API_LOAN_DOWNLOAD_FEE_WORKSHEET,
  API_LOAN_DOWNLOAD_HUD1_PDF,
  API_LOAN_DOWNLOAD_HUD1_TEMPLATE_PDF,
  API_LOAN_DOWNLOAD_MLDS,
  API_LOAN_DOWNLOAD_NET_FUNDING_SHEET,
  API_LOAN_GET_ELECTIVE_CLOSING_COSTS,
  API_LOAN_GET_HUD1_NOTES,
  API_LOAN_GET_HUD1_PAGE1,
  API_LOAN_GET_LOG_HUD1_PAGE1,
  API_LOAN_PROGRAM_HUD1,
  API_LOAN_SEND_SIGN_MLDS_REQUEST,
  API_LOAN_SIGN_MLDS,
} from 'config'
import Api from 'services/api'

export const gethud1PageData = (page: string, templateNo?: number) => {
  return Api.get(API_LOAN_GET_HUD1_PAGE1, { isTemplate: !!templateNo, templateNo }, { page }, { timeout: 150000 })
}

export const posthud1Page1Data = (page: string, data: any) => {
  return Api.post(API_LOAN_GET_HUD1_PAGE1, data, { page })
}

export const getHUD1Logs = (key: string) => {
  return Api.get(API_LOAN_GET_LOG_HUD1_PAGE1, {}, { key })
}

export const posthud1Notes = (key: string, data: Record<string, any>) => {
  return Api.post(API_LOAN_GET_HUD1_NOTES, data, { key })
}

export const getElectiveClosingCosts = (templateNo?: number) => {
  return Api.get(API_LOAN_GET_ELECTIVE_CLOSING_COSTS, { templateNo })
}

export const addClosingCosts = (data: Array<any>, templateNo?: number) => {
  return Api.post(API_LOAN_ADD_CLOSING_COSTS, { data, templateNo })
}

export const getClosingCostSetup = (id: number) => {
  return Api.get(API_GET_CLOSING_COST_SETUP, {}, { id })
}

export const deleteClosingCost = (id: number, isTemplate?: boolean, templateNo?: number) => {
  return Api.post(API_LOAN_DELETE_CLOSING_COST, { isTemplate, templateNo }, { id })
}

export const downloadHUD1PDF = (page: string) => {
  return Api.get(API_LOAN_DOWNLOAD_HUD1_PDF, {}, { page }, { responseType: 'blob', timeout: 150000 })
}

export const downloadHUD1TemplatePDF = (page: string) => {
  return Api.get(API_LOAN_DOWNLOAD_HUD1_TEMPLATE_PDF, {}, { page }, { responseType: 'blob', timeout: 150000 })
}

export const downloadNetFundingSheet = () => {
  return Api.get(API_LOAN_DOWNLOAD_NET_FUNDING_SHEET, {}, {}, { responseType: 'blob', timeout: 150000 })
}

export const downloadFeeWorksheet = () => {
  return Api.get(API_LOAN_DOWNLOAD_FEE_WORKSHEET, {}, {}, { responseType: 'blob', timeout: 150000 })
}

export const getClosingCostEstimate = () => {
  return Api.get(API_LOAN_CLOSING_COST_ESTIMATE_HUD1)
}

export const getLoanProgram = () => {
  return Api.get(API_LOAN_PROGRAM_HUD1)
}

export const exportDisbursementItems = (liabilities: Array<any>) => {
  return Api.post(API_LOAN_DOWNLOAD_DISBURSEMENT_ITEMS, { liabilities }, {}, { responseType: 'blob', timeout: 150000 })
}

export const downloadMLDS = () => {
  return Api.get(API_LOAN_DOWNLOAD_MLDS, {}, {}, { responseType: 'blob', timeout: 150000 })
}

export const downloadClosingInformation = () => {
  return Api.get(API_LOAN_DOWNLOAD_CLOSING_INFORMATION, {}, {}, { responseType: 'blob', timeout: 150000 })
}

export const downloadCreditDenialPdf = () => {
  return Api.get(API_LOAN_DOWNLOAD_CREDIT_DENIAL, {}, {}, { responseType: 'blob', timeout: 150000 })
}

export const addCreditDenialPdf = () => {
  return Api.get(API_LOAN_ADD_CREDIT_DENIAL)
}

export const signMlds = () => {
  return Api.get(API_LOAN_SIGN_MLDS, {}, {}, { timeout: 150000 })
}

export const sendMldsSignatureRequest = () => {
  return Api.post(API_LOAN_SEND_SIGN_MLDS_REQUEST)
}

export const downloadAggregateEscrow = (tableData: Array<any>, totalCushion: number) => {
  return Api.get(
    API_LOAN_DOWNLOAD_AGGREGATE_ESCROW,
    { tableData, cushion: totalCushion },
    {},
    { responseType: 'blob', timeout: 150000 },
  )
}

export const changeTemplate = (templateNo: number, data: Record<string, any>) => {
  return Api.post(API_LOAN_CHANGE_FEE_WORKSHEET_TEMPLATE, data, { templateNo }, { timeout: 150000 })
}
